<template>
	<div>
		<p class="delete-loan-text">Are you sure you want to delete this loan?</p>
		<OverviewModalFooter
			:success="success"
			:waiting="waiting"
			:isDeleteModal="true"
			@handleClick="handleDeleteLoan"
			@close="handleClose"
			primaryButtonName="Delete"
		/>
	</div>
</template>

<script>
import loansService from '@/services/contacts/loans-service.js';
import OverviewModalFooter from './OverviewModalFooter.vue';

export default {
	name: 'DeleteLoan',
	components: {
		OverviewModalFooter,
	},
	props: {
		loanId: Number,
	},
	data() {
		return {
			success: false,
			waiting: false,
			error: null,
		};
	},
	methods: {
		async handleDeleteLoan() {
			this.waiting = true;
			try {
				await loansService.deleteLoan({ loanId: this.loanId });
				this.waiting = false;
				this.success = true;
				setTimeout(() => {
					this.$emit('loanDeleted');
					this.success = false;
				}, 1500);
			} catch (error) {
				this.error = error;
				this.waiting = false;
			}
		},
		handleClose() {
			this.$emit('close');
		},
	},
};
</script>

<style lang="scss" scoped>
.delete-loan-text {
	display: flex;
	align-items: center;
	@include rem('padding', 10px 20px);
}
</style>
